export default {"src":"/_next/static/media/Research_Communication.b57c0d60.svg","height":284,"width":284};